"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialSendGridIntValues = exports.SENDGRID = void 0;
exports.SENDGRID = "SENDGRID";
exports.initialSendGridIntValues = { type: exports.SENDGRID, data: { api_key: "", sender_email: "" } };
